import { z } from 'zod';

const optionalText = z.string().trim().optional().default('');
const clientEnvSchema = z.object({
  VITE_FIREBASE_API_KEY: optionalText,
  VITE_FIREBASE_AUTH_DOMAIN: optionalText,
  VITE_FIREBASE_PROJECT_ID: optionalText,
  VITE_FIREBASE_STORAGE_BUCKET: optionalText,
  VITE_FIREBASE_MESSAGING_SENDER_ID: optionalText,
  VITE_FIREBASE_APP_ID: optionalText,
  VITE_RECAPTCHA_ENTERPRISE_SITE_KEY: optionalText,
  VITE_ENABLE_APP_CHECK: z.enum(['true', 'false']).optional().default('false'),
  VITE_ENABLE_EXPERIMENTAL_3D: z.enum(['true', 'false']).optional().default('false'),
  VITE_USE_EMULATORS: z.enum(['true', 'false']).optional().default('false'),
  VITE_CANONICAL_URL: z.url().optional().default('http://localhost:5173'),
});

const parsed = clientEnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(`Configuración de entorno inválida: ${z.prettifyError(parsed.error)}`);
}

const raw = parsed.data;
const firebaseRequired = [
  raw.VITE_FIREBASE_API_KEY,
  raw.VITE_FIREBASE_AUTH_DOMAIN,
  raw.VITE_FIREBASE_PROJECT_ID,
  raw.VITE_FIREBASE_APP_ID,
];

export const env = {
  firebase: {
    apiKey: raw.VITE_FIREBASE_API_KEY,
    authDomain: raw.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: raw.VITE_FIREBASE_PROJECT_ID,
    storageBucket: raw.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: raw.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: raw.VITE_FIREBASE_APP_ID,
  },
  recaptchaEnterpriseSiteKey: raw.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY,
  enableAppCheck: raw.VITE_ENABLE_APP_CHECK === 'true',
  enableExperimental3d: raw.VITE_ENABLE_EXPERIMENTAL_3D === 'true',
  useEmulators: raw.VITE_USE_EMULATORS === 'true',
  canonicalUrl: raw.VITE_CANONICAL_URL.replace(/\/$/, ''),
  firebaseConfigured: firebaseRequired.every(Boolean),
} as const;
